var map = {
	"./AbHeader1.jpg": 8855,
	"./AbHeader2.jpg": 6280,
	"./AbHeader3.jpg": 7189,
	"./AbHeader4.jpg": 2654,
	"./AbHeader5.jpg": 9115,
	"./AbHeader6.jpg": 1420,
	"./AbHeader7.jpg": 8793,
	"./AbHeader8.jpg": 9170,
	"./AboutusHer01.jpg": 2599,
	"./AboutusHero2.jpg": 3857,
	"./BengalGram.jpg": 8198,
	"./BlackGram.jpg": 52,
	"./Chickpeas.jpg": 2629,
	"./ChittiMuthuallu.jpg": 228,
	"./Cinamon.jpg": 7327,
	"./Cloves.jpg": 2592,
	"./Ginger.jpg": 586,
	"./GreenChilli.jpg": 4234,
	"./GreenGram.jpg": 4124,
	"./KidneyBeans.jpg": 6349,
	"./MainSpices.jpg": 3604,
	"./PigeonPeas.jpg": 5629,
	"./Raw-Pepper.jpg": 7121,
	"./RedChilli.jpg": 8570,
	"./RedLentils.jpg": 4562,
	"./Rice.jpg": 7197,
	"./SpicesCombo.jpg": 7185,
	"./SpicesPowder.jpg": 2900,
	"./Star-Anise.jpg": 5187,
	"./allspices.jpg": 1224,
	"./allspies.jpg": 5223,
	"./cardamom.jpg": 3338,
	"./cinnamon.jpg": 499,
	"./connectbanner.jpg": 5048,
	"./fenugreek.jpg": 2964,
	"./international_exports.jpg": 5952,
	"./pepper.jpg": 9218,
	"./star.jpg": 2694,
	"./vision.jpg": 6398
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1721;